import React from "react";
import { FiltersTypes } from "@common/types/filters/general";
import { RuleReviewStatus } from "@common/types/transactionRule";

interface RuleReviewFilterLabelProps {
    filters: Pick<FiltersTypes, "ruleReviewStatuses">;
}

const STATUS_LABELS: Record<RuleReviewStatus, string> = {
    [RuleReviewStatus.REVIEWED]: "Reviewed",
    [RuleReviewStatus.UNREVIEWED]: "Unreviewed",
};

export const RuleReviewFilterLabel: React.FC<RuleReviewFilterLabelProps> = ({
    filters,
}) => (
    <>
        {(filters.ruleReviewStatuses ?? [])
            .map((status) => STATUS_LABELS[status])
            .join(", ")}
    </>
);
